import formatAddress from "@/utils/propertyAddress";
import LocationIcon from "@/assets/svg/LocationIcon";

const LocationLabel = ({ location }) => {
  return (
    <div className="flex flex-row items-center">
      <LocationIcon color={"#31493C"} width="14px" height="14px" />
      <p
        className={`text-[#596460] font-sans truncate px-2 text-sm font-normal`}>
        {formatAddress(location)}
      </p>
    </div>
  );
};

export default LocationLabel;
